// extracted by mini-css-extract-plugin
module.exports = {"admin":"adminOrder_admin__1UUAl","imgBackground":"adminOrder_imgBackground__3sZJB"};